module.exports = __webpack_public_path__ + "static/media/MHRP29N0005.2667851a.svg";